"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var CmsBannerRouteEditor_1 = require("./component/CmsBannerRouteEditor");
var CmsBannerRouteImageEditor_1 = require("./component/CmsBannerRouteImageEditor");
var CmsBannerRouteList_1 = require("./component/CmsBannerRouteList");
var CmsBannerRouteImagesList_1 = require("./component/CmsBannerRouteImagesList");
var PCmsBannersList = /** @class */ (function (_super) {
    __extends(PCmsBannersList, _super);
    function PCmsBannersList(props) {
        return _super.call(this, props) || this;
    }
    PCmsBannersList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.listBrandsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_brands: data.data
            });
        });
        this.SID_AL = this.props.listAppLangsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_langs: data.data
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST-BANNER-URL",
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_langs: [],
            page_url_num: 1,
            page_size: this.props.state.getTablePageSize(),
            page_image_num: 1
        }, function () {
            _this.props.listBrandsAvail.LoadData();
            _this.props.listAppLangsAvail.LoadData();
        });
    };
    PCmsBannersList.prototype.componentWillUnmount = function () {
        this.props.listBrandsAvail.UnSubscribe(this.SID_AB);
        this.props.listAppLangsAvail.UnSubscribe(this.SID_AL);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PCmsBannersList.prototype.onNewBannerUrlClick = function () {
        this.setState({ edit_mode: "NEW-BANNER-URL", item_url: null });
    };
    PCmsBannersList.prototype.onNewBannerImageClick = function () {
        this.setState({ edit_mode: "NEW-BANNER-IMAGE", item_image: null });
    };
    PCmsBannersList.prototype.onEditBannerUrlClick = function (id) {
        this.setState({ edit_mode: "EDIT-BANNER-URL", item_url: id });
    };
    PCmsBannersList.prototype.onEditBannerImageClick = function (id) {
        this.setState({ edit_mode: "EDIT-BANNER-IMAGE", item_image: id });
    };
    PCmsBannersList.prototype.onBannerUrlDetailsClick = function (id) {
        this.setState({ edit_mode: "LIST-BANNER-IMAGE", item_url: id, item_image: null });
    };
    PCmsBannersList.prototype.onGoBackToBannerUrlListClick = function () {
        this.setState({ edit_mode: "LIST-BANNER-URL", item_url: null, item_image: null });
    };
    PCmsBannersList.prototype.onGoBackToBannerImageListClick = function () {
        this.setState({ edit_mode: "LIST-BANNER-IMAGE", item_image: null });
    };
    PCmsBannersList.prototype.onPageBannerUrlConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_url_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCmsBannersList.prototype.onPageBannerImageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_image_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCmsBannersList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PCmsBannersList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW-BANNER-URL") {
            return (React.createElement(CmsBannerRouteEditor_1.default, { data: this.props.dataUrls, state: this.props.state, record: null, onGoBack: this.onGoBackToBannerUrlListClick.bind(this), brandsList: this.state.avail_brands }));
        }
        if (this.state.edit_mode === "NEW-BANNER-IMAGE") {
            return (React.createElement(CmsBannerRouteImageEditor_1.default, { data: this.props.dataImages, record: this.state.item_image, rootRecord: this.state.item_url, state: this.props.state, languagesList: this.state.avail_langs, onGoBack: this.onGoBackToBannerImageListClick.bind(this), dialogSelectImage: this.props.dialogSelectImage, dlgSelectCss: this.props.dlgSelectKeyValue, 
                //listCssClasses={this.props.listCssClasses}
                listAuthTypes: this.props.listAuthTypes }));
        }
        if (this.state.edit_mode === "EDIT-BANNER-URL") {
            return (React.createElement(CmsBannerRouteEditor_1.default, { data: this.props.dataUrls, state: this.props.state, record: this.state.item_url, onGoBack: this.onGoBackToBannerUrlListClick.bind(this), brandsList: this.state.avail_brands }));
        }
        if (this.state.edit_mode === "EDIT-BANNER-IMAGE") {
            return (React.createElement(CmsBannerRouteImageEditor_1.default, { data: this.props.dataImages, record: this.state.item_image, rootRecord: this.state.item_url, state: this.props.state, languagesList: this.state.avail_langs, onGoBack: this.onGoBackToBannerImageListClick.bind(this), dialogSelectImage: this.props.dialogSelectImage, dlgSelectCss: this.props.dlgSelectKeyValue, 
                //listCssClasses={this.props.listCssClasses}
                listAuthTypes: this.props.listAuthTypes }));
        }
        if (this.state.edit_mode === "LIST-BANNER-URL") {
            return (React.createElement(CmsBannerRouteList_1.default, { data: this.props.dataUrls, state: this.props.state, onNewClick: this.onNewBannerUrlClick.bind(this), onEditClick: this.onEditBannerUrlClick.bind(this), onPageConfigChanged: this.onPageBannerUrlConfigChange.bind(this), pageNum: this.state.page_url_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onDetailsClick: this.onBannerUrlDetailsClick.bind(this) }));
        }
        if (this.state.edit_mode === "LIST-BANNER-IMAGE") {
            return (React.createElement(CmsBannerRouteImagesList_1.default, { data: this.props.dataImages, state: this.props.state, bannerUrl: this.state.item_url, onNewClick: this.onNewBannerImageClick.bind(this), onEditClick: this.onEditBannerImageClick.bind(this), onPageConfigChanged: this.onPageBannerImageConfigChange.bind(this), pageNum: this.state.page_image_num, pageSize: this.state.page_size, onGoBackClick: this.onGoBackToBannerUrlListClick.bind(this), rootRecord: this.state.item_url }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PCmsBannersList.prototype.render = function () {
        return this.getRenderObject();
    };
    PCmsBannersList.getPageDescription = function (state) {
        return {
            icon: "sign",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_cms_banners_list + "-id",
            itemTitle: "Баннеры",
            route: routes_1.routes.page_cms_banners_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PCmsBannersList;
}(React.Component));
exports.default = PCmsBannersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_banners/ui/PCmsBannersList.tsx
// module id = 2384
// module chunks = 0